export const GST_RATE = 10;
export const GST_MULTIPLIER = 1.1;
export const GST_DIVIDER = 11;
export const SYSTEMS_STALE_TIME_5_MINS = 300000; // 5 mins in milliseconds
export const MENU_SYSTEMS_STALE_TIME_5_MINS = 900000; // 5 mins in milliseconds
export const ACCOUNT_STALE_TIME_5_MINS = 300000; // 5 mins in millisecons
export const BASKET_STALE_TIME_5_MINS = 300000; // 5 mins in millisecons
export const EXCELERA_REFRESH_INTERVAL = 300000;
export const PROXY_CONFIG = null;
export const SERVER_PORT = 3015;